import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { useAuth } from "@/auth/AuthContext";
import { createApiClient } from "@/api/client";
import { queryKeys } from "@/api/queryClient";
import type { AgentBudgetStatus, UserBudgetStatus } from "@/types";

// #223 UC-5: Budget-Status (Read, admin-only am Master). Aktueller Monatsstand +
// Limits + (Agent) History bzw. (User) per-Agent-Aufschlüsselung.
export function useAgentBudget(agentId: string): UseQueryResult<AgentBudgetStatus> {
  const { session, logout } = useAuth();
  return useQuery({
    queryKey: queryKeys.subResource("agents", agentId, "budget"),
    queryFn: () =>
      createApiClient({ getToken: () => session?.accessToken ?? null, onUnauthorized: logout }).get<AgentBudgetStatus>(
        `/agents/${agentId}/budget`,
      ),
    enabled: !!session,
  });
}

export function useUserBudget(userId: string): UseQueryResult<UserBudgetStatus> {
  const { session, logout } = useAuth();
  return useQuery({
    queryKey: queryKeys.subResource("users", userId, "budget"),
    queryFn: () =>
      createApiClient({ getToken: () => session?.accessToken ?? null, onUnauthorized: logout }).get<UserBudgetStatus>(
        `/users/${userId}/budget`,
      ),
    enabled: !!session,
  });
}
